import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';


import {TranslateService} from '@ngx-translate/core';
import {HeaderNotificationsService} from '../header-notifications/header-notifications.service';
import {environment} from '../../../../environments/environment';
import { EventComponent } from '../../components/event/event.component'
import {NgIf} from '@angular/common';

const eventLogUrl = environment.backEndUrlPrefix.substring(0,environment.backEndUrlPrefix.indexOf('sem-restservices')) + 'app/#!/main/eventslog/list';
//http://10.3.2.103/app/#!/main/eventslog/list

@Component({
  selector: 'app-header-notification-toast',
  templateUrl: './header-notification-toast.component.html',
  styleUrls: ['./header-notification-toast.component.scss'],
  imports: [EventComponent, NgIf]
})
export class HeaderNotificationToastComponent implements OnInit, OnDestroy, OnChanges {
  contentHeight: number;

  @Input() notificationMessage: any = {};
  @Output() acceptMessage? = new EventEmitter<any>();

  lastMessage;
  message: any;



  constructor(private headerNotificationService: HeaderNotificationsService,
              private translateService: TranslateService,
              private element: ElementRef,
              private translate: TranslateService) {
  }

  ngOnInit() {
    console.log('HeaderNotificationToast');
  }

  ngOnDestroy() {
    console.log('HeaderNotificationToast');
  }

  ngOnChanges(changes: SimpleChanges) {
    this.lastMessage = this.notificationMessage;
  }

  protected readonly eventLogUrl = eventLogUrl;

  onAccept(event) {
    this.acceptMessage.emit(this.lastMessage);
  }
}
